
import { defineComponent, ref } from "vue";
import axios from "@/axios-instance"
import { hideModal } from "@/core/helpers/dom";
export default defineComponent({
  name: "modalDeleteAndReason",
  emits:["callBackDelete"],
  props: {
    ids: Array,
    id: String,
    title: String,
    warningText: String,
    warningItems: { type: Array, default: () => [] },
    // Có giá trị = KHÔNG cho xóa (hiện lý do, khóa nút Xác nhận)
    blockedText: { type: String, default: "" },
  },
  methods: {
    showModal() {
        this.call_modal_delete.click()
    },
    closeModal(){
        this.comment_profile = ''
        hideModal(this.addDeleteModalRef)
    },
    async submitComment() {
      if (this.comment_profile == '') {
        return;
      }

      this.$emit("callBackDelete",this.comment_profile)
      this.comment_profile = ''
      hideModal(this.addDeleteModalRef)
    },
  },
  setup() {
    const addDeleteModalRef = ref<null | HTMLElement>(null);
    const call_modal_delete = ref<any>();
    const comment_profile = ref('')
    function user() {
      let temp  = window.localStorage.getItem("user")
      return temp?JSON.parse(temp) : null
    }
    return {
        call_modal_delete,
        addDeleteModalRef,
        comment_profile,
        user
    };
  },
});
